export default class ApiCall {
  constructor(sDefaultUrl) {
    this.sDefaultUrl = sDefaultUrl;
    this.init();
  }

  init() {
    this.cacheElement();
    this.setEvent();
  }

  cacheElement() {
    this.welApiWrapper = $('#_debug_api_call');
    this.welApiArea = this.welApiWrapper.find('#_debug_api_area');
    this.welApiInput = this.welApiArea
      .find('#_debug_api_controller')
      .find('input');
    this.welApiIframe = this.welApiArea.find('iframe');
  }

  setEvent() {
    this.welApiWrapper.on('click', '#_debug_api_area_button', e => {
      this.onClickToggleArea(e);
    });
    this.welApiWrapper.on('click', '#_debug_api_reset', () => {
      this.onClickReset();
    });
    this.welApiWrapper.on('click', '#_debug_api_action', () => {
      this.onClickAction();
    });
  }

  onClickToggleArea(e) {
    const welArea = this.welApiArea;
    const welButton = $(e.currentTarget);
    const bAreaOpen = welArea.hasClass('on');
    const sButtonText = bAreaOpen
      ? 'api 호출 영역 펼치기'
      : 'api 호출 영역 접기';

    welArea.toggleClass('on');
    welButton.text(sButtonText);
  }

  onClickReset() {
    this.welApiInput.val(this.sDefaultUrl);
  }

  onClickAction() {
    this.welApiIframe.attr('src', this.welApiInput.val());
  }
}
